











import Vue from "vue";
import Component from "vue-class-component";
import { Emit, Prop } from "vue-property-decorator";
import NumberInput from "@/components/common/NumberInput.vue";

@Component({
  components: {
    NumberInput
  }
})
export default class OneService extends Vue {
  @Prop({ default: "" }) label1!: string;
  @Prop({ default: "" }) label2!: string;
  @Prop({ default: 0 }) totalmoney!: number;
  @Prop({ default: "0px" }) left!: string;
  @Prop({ default: 1 }) lines!: number;

  public get Totalmoney() {
    return this.totalmoney;
  }
  public set Totalmoney(newValue) {
    this.updateTotal(newValue);
    this.changealltotal();
  }

  @Emit("update:totalmoney")
  public updateTotal(newValue: unknown) {
    return newValue;
  }

  @Emit("changealltotal")
  public changealltotal() {
    return;
  }
}
